"use client";

import { jsx as l, jsxs as t } from "react/jsx-runtime";
import { useState as w, useEffect as x } from "react";
import { createPortal as b } from "react-dom";
import y from './../../external/react-focus-lock/dist/es2015/Combination.js';
import { classNames as C } from "../../utilities/index.js";
import N from "../Container/index.js";
import i from "../Collapse/index.js";
const g = _ref => {
    let {
      videoId: r,
      title: a,
      onClose: u,
      isOpen: o,
      className: c,
      transcript: n,
      children: p,
      internal: s,
      ...h
    } = _ref;
    const [m, f] = w(null);
    x(() => {
      let e = document.getElementById("portal") || null;
      e || (e = document.createElement("div"), e.setAttribute("id", "portal"), document.body.appendChild(e));
      const d = document.createElement("div");
      return e == null || e.appendChild(d), f(d), () => {
        e == null || e.removeChild(d);
      };
    }, []);
    const v = C({
      "sash-VideoModal fixed left-0 top-0 z-50 overflow-auto overscroll-contain h-full w-full bg-black items-center": !0,
      flex: o,
      hidden: !o,
      [c]: c
    });
    return !m || !o ? null : b(/* @__PURE__ */l(y, {
      returnFocus: !0,
      children: /* @__PURE__ */l("div", {
        id: r,
        className: v,
        role: "dialog",
        "aria-hidden": !o,
        ...h,
        children: /* @__PURE__ */t(N, {
          fluid: !1,
          className: "m-auto py-16 md:py-10",
          children: [/* @__PURE__ */t("button", {
            className: "sash-VideoModal-Close absolute left-1 top-1 cursor-pointer hover:opacity-70",
            onClick: u,
            children: [/* @__PURE__ */l("span", {
              className: "block px-4 text-7xl font-light text-white",
              children: "×"
            }), /* @__PURE__ */l("span", {
              className: "sr-only",
              children: "Close"
            })]
          }), !s && r && /* @__PURE__ */l("iframe", {
            loading: "lazy",
            src: `https://www.youtube.com/embed/${r}?rel=0&enablejsapi=1&autoplay=1&mute=1`,
            allowFullScreen: !0,
            title: a,
            className: "sash-VideoModal-Iframe aspect-video w-full"
          }), s && /* @__PURE__ */l("video", {
            className: "sash-VideoModal-Video aspect-video w-full",
            preload: "none",
            title: a,
            controls: !0,
            children: /* @__PURE__ */l("source", {
              src: s,
              type: "video/mp4"
            })
          }), n && /* @__PURE__ */l("div", {
            className: "sash-VideoModal-Transcript mt-4",
            children: /* @__PURE__ */t(i, {
              className: "border-0 text-white [&_span]:text-white",
              children: [/* @__PURE__ */t(i.Trigger, {
                children: ["Transcript for ", a]
              }), /* @__PURE__ */l(i.Content, {
                className: "px-2.5",
                children: /* @__PURE__ */l("div", {
                  dangerouslySetInnerHTML: {
                    __html: n
                  }
                })
              })]
            })
          }), p]
        })
      })
    }), m);
  },
  S = g;
export { S as default };